// extracted by mini-css-extract-plugin
export default {"container":"EmailSubject_container__PVT+m","subject":"EmailSubject_subject__ymKjJ","subjectText":"EmailSubject_subjectText__Jf0Fu"};